/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbăta", "Duminică"], t = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"], n = "Ani", i = "An", o = "Lună", a = "Săptămână", c = "Zile", r = "Zi", s = "Azi", u = "Nici o interacțiune", d = "Toată ziua", m = "Șterge", M = "Adaugă un eveniment", l = "dddd D MMMM YYYY", y = {
  weekDays: e,
  months: t,
  years: n,
  year: i,
  month: o,
  week: a,
  days: c,
  day: r,
  today: s,
  noEvent: u,
  allDay: d,
  deleteEvent: m,
  createEvent: M,
  dateFormat: l
};
export {
  d as allDay,
  M as createEvent,
  l as dateFormat,
  r as day,
  c as days,
  y as default,
  m as deleteEvent,
  o as month,
  t as months,
  u as noEvent,
  s as today,
  a as week,
  e as weekDays,
  i as year,
  n as years
};
